<template>
  <div v-if="asyncDataStatus_ready">
    <h2>Profil podjetja {{ company.name }}</h2>
    <v-row>
      <v-col col="12" md="8" offset-md="2" lg="6" offset-lg="3">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>Ime:</td>
                <td>{{ company.name }}</td>
              </tr>
              <tr>
                <td>Ulica:</td>
                <td>{{ company.address }}</td>
              </tr>
              <tr>
                <td>Poštna številka:</td>
                <td>{{ company.post_code }}</td>
              </tr>
              <tr>
                <td>Mesto:</td>
                <td>{{ company.city }}</td>
              </tr>
              <tr>
                <td>Država:</td>
                <td>{{ company.country }}</td>
              </tr>
              <tr>
                <td>Davčna številka:</td>
                <td>{{ company.tax_number }}</td>
              </tr>
              <tr>
                <td>Matična številka:</td>
                <td>{{ company.register_number }}</td>
              </tr>
              <tr>
                <td>Številka računa:</td>
                <td>{{ company.account_number }}</td>
              </tr>
              <tr>
                <td>Kontaktna oseba:</td>
                <td>{{ company.contact }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <h2 class="mt-10">
      Seznam uporabnikov
    </h2>
    <v-row>
      <v-col
        cols="12" md="6" xl="4"
        v-for="user of company.users" :key="user.id"
      >
        <UserCard
          :user="user"
          :disabled="user.is_super_administrator"
          @edit="$router.push({name: userEditRouteName, params: { id: user.id }})"
          @delete="showDeleteUserModal = true; deleteUser = user"
          @resetPass="$router.push({name: userResetPassRouteName, params: { id: user.id }})"
        />
      </v-col>
    </v-row>
    <v-btn text type="button" class="float-right" @click="$router.go(-1)">Nazaj</v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import UserCard from '@/components/UserCard'

export default {
  components: {
    UserCard
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  computed: {
    ...mapGetters('auth', ['childCompanyUserIsTaken']),
    company () {
      return this.$store.state.companies.childCompanies[this.id]
    },
    userEditRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsersEdit' : 'UsersEdit'
    },
    userResetPassRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsersResetPass' : 'UsersResetPass'
    }
  },
  methods: {
    ...mapActions('companies', ['loadChildCompany', 'loadMyCompany', 'loadChildCompanyUsers'])
  },
  created () {
    Promise.all([
      this.loadMyCompany(),
      this.loadChildCompany(this.id)
    ])
      .then(done => {
        this.loadChildCompanyUsers(this.id)
          .then(results => { this.asyncDataStatus_fetched() })
      })
  }
}
</script>
